import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Element } from 'react-scroll';
import { propArrayShape, propBool, propNumber, propShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import Select2FieldsComponent from '../../../../Common/Fields/Select2Fields/Select2FieldsComponent';
const SolutionBaseSelect = (props) => {
    const { candidateValues, input, isMulti, maximum, meta, placeholder } = props;
    return (_jsx(Element, Object.assign({ name: `${input.name}_view` }, { children: _jsx(Select2FieldsComponent, { blurInputOnSelect: false, candidateValues: candidateValues, input: input, isMulti: isMulti, maximum: maximum, meta: meta, placeholder: placeholder }) })));
};
SolutionBaseSelect.propTypes = {
    candidateValues: propArrayShape().isRequired,
    input: propShape().isRequired,
    isMulti: propBool().isRequired,
    maximum: propNumber().isRequired,
    meta: propShape().isRequired,
    placeholder: propStr().isRequired,
};
export default SolutionBaseSelect;
